import React from 'react';
import classnames from 'classnames';
import { IconComp } from '../IconComponent';

export enum ButtonSizes {
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
  XL = 'xl',
  XXL = 'xxl',
}

export interface ISKButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  color: 'primary' | 'secondary' | 'tertiary' | 'tertiary-grey' | undefined;
  disabled?: boolean;
  iconLeft?: React.ReactType;
  iconRight?: React.ReactType;
  label?: string;
  size: ButtonSizes;
  // onClick: (ev: MouseEvent) => void;
  onlyIcon?: boolean | undefined;
  leftIconClasses?: string;
  rightIconClasses?: string;
}

export const SKButton: React.FC<ISKButtonProps> = ({
  color,
  size,
  className,
  disabled,
  onClick,
  onlyIcon,
  rightIconClasses,
  leftIconClasses,
  iconLeft,
  iconRight,
  ...props
}) => {
  return (
    <>
      {!onlyIcon && (
        <button
          type="button"
          onClick={onClick}
          className={classnames(
            {
              'px-1.75 py-1 gap-x-1 text-sm': size === ButtonSizes.SM,
              'px-2 py-1.25 gap-x-1 text-sm': size === ButtonSizes.MD,
              'px-2.25 py-1.25 gap-x-1 text-md': size === ButtonSizes.LG,
              'px-2.5 py-1.5 gap-x-1 text-md': size === ButtonSizes.XL,
              'px-4 py-2.75 gap-x-1.5 text-lg': size === ButtonSizes.XXL,
              'bg-kiwi-400 focus:bg-cloud-900 focus:text-white': color === 'primary' && !disabled,
              'bg-white focus:bg-cloud-200': color === 'secondary' && !disabled,
              'bg-lemon-400 focus:bg-cloud-900 focus:text-white': color === 'tertiary' && !disabled,
              'bg-cloud-100 focus:bg-cloud-200 hover:bg-cloud-200': color === 'tertiary-grey' && !disabled,
              'cursor-not-allowed bg-white text-cloud-400': disabled && color !== 'tertiary-grey',
              'border-cloud-900': !disabled && color !== 'tertiary-grey',
              'cursor-not-allowed bg-cloud-50 text-cloud-300': disabled && color === 'tertiary-grey',
              border: color !== 'tertiary-grey',
              'sk-cta': color !== 'tertiary-grey',
            },
            'rounded-xl text-black flex items-center justify-center transition ease-in-out duration-100',
            className,
          )}
          disabled={disabled ? disabled : false}
          {...props}
        >
          {iconLeft && (
            <IconComp
              icon={iconLeft}
              size={size === ButtonSizes.XXL ? 22 : 16.67}
              className={classnames(leftIconClasses)}
            />
          )}
          {props.children ? props.children : props.label}
          {iconRight && (
            <IconComp
              icon={iconRight}
              size={size === ButtonSizes.XXL ? 22 : 16.67}
              className={classnames(rightIconClasses)}
            />
          )}
        </button>
      )}
      {onlyIcon && (
        <button
          type="button"
          onClick={onClick}
          className={classnames(
            {
              'p-1': size === ButtonSizes.SM,
              'p-1.25': size === ButtonSizes.MD,
              'p-1.5': size === ButtonSizes.LG,
              'p-1.75': size === ButtonSizes.XL,
              'p-2.75': size === ButtonSizes.XXL,
              'bg-kiwi-400 focus:bg-cloud-900 focus:text-white': color === 'primary' && !disabled,
              'bg-white focus:cloud-200': color === 'secondary' && !disabled,
              'bg-lemon-400 focus:bg-cloud-900 focus:text-white': color === 'tertiary' && !disabled,
              'bg-cloud-100 focus:bg-cloud-200 hover:bg-cloud-200': color === 'tertiary-grey' && !disabled,
              'cursor-not-allowed bg-white text-cloud-400 border-cloud-400': disabled,
              'border-cloud-900': !disabled,
            },
            'sk-cta rounded-xl text-black border transition ease-in-out duration-100',
            className,
          )}
          disabled={disabled ? disabled : false}
          {...props}
        >
          {props.children}
          {iconLeft && (
            <IconComp
              icon={iconLeft}
              size={size === ButtonSizes.XXL ? 22 : 16.67}
              className={classnames(leftIconClasses)}
            />
          )}
        </button>
      )}
    </>
  );
};
